<template>
    <div class="spinner_container dots">
        <pulse_loader
            :color="color"
            :size="size"
        />
    </div>
</template>

<script>
import pulse_loader from "vue-spinner/src/PulseLoader.vue";
export default {
    name: "spinner_dots",
    props:{
        color: {
            type: String,
            default: '#F6673C'
        },
        size: {
            type: String,
            default: '35px'
        },
    },
    components:{pulse_loader},
}
</script>
